var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMobileTimeIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16.144,
    height: 16.13,
    viewBox: "0 0 16.144 16.13",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_9225",
    "data-name": "Group 9225",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_26",
    "data-name": "Path 26",
    d: "M244.61,125.69l.509,1.008-3.233-.766,1.545-2.375.51.868a6.494,6.494,0,0,0,3.269-5.141,6.308,6.308,0,0,0-3.085-6.257c-2.764-1.713-5.463-1.336-8.024.618l-.872-.971c3.01-2.983,8.307-2.69,11.306.564A8.146,8.146,0,0,1,244.61,125.69Z",
    transform: "translate(-232.47 -110.607)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_27",
    "data-name": "Path 27",
    d: "M246.839,119.99v.89c-.877,0-1.73-.02-2.583.011a2.735,2.735,0,0,0-.9.227.823.823,0,0,1-1.075-.22.777.777,0,0,1,.1-1.079,1.071,1.071,0,0,0,.229-.64c.02-1.406.01-2.813.01-4.259l.542-.039a2.507,2.507,0,0,1,.042.3c0,1.333,0,2.666,0,4,0,.614.19.8.819.805C244.956,119.993,245.885,119.99,246.839,119.99Z",
    transform: "translate(-235.053 -112.212)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28",
    "data-name": "Path 28",
    d: "M231.043,118.883l1.309-2.922,1.125.8-1.09,2.5Z",
    transform: "translate(-230.898 -112.618)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_29",
    "data-name": "Path 29",
    d: "M232.4,124.962l-1.271.606-.317-2.419h1.379Z",
    transform: "translate(-230.811 -115.317)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_30",
    "data-name": "Path 30",
    d: "M233.128,127.587l1.08,1.768-1.029.9-1.2-1.874Z",
    transform: "translate(-231.251 -116.984)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31",
    "data-name": "Path 31",
    d: "M237.963,134.286l-1.922-1.063.8-1.131,1.63.919Z",
    transform: "translate(-232.775 -118.676)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32",
    "data-name": "Path 32",
    d: "M243.622,135.561l-2.026-.1.207-1.3C243.137,133.987,243.323,134.12,243.622,135.561Z",
    transform: "translate(-234.861 -119.431)",
    fill: "#fff"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMobileTimeIcon);
export default __webpack_public_path__ + "static/media/MobileTimeIcon.01c757d6b57fcc6f96b372c99a8c01bc.svg";
export { ForwardRef as ReactComponent };